import * as React from "react";
import C from "classnames";
export const ModalTitle = (props) => {
    return (React.createElement("h4", { className: C("modal-title", props.className), "data-testid": props.testId }, props.children));
};
//# sourceMappingURL=ModalTitle.js.map